import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconWaterski = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconWaterski",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M18.16 5.6h-4.25v.67h4.25q.15 0 .24-.1a.33.33 0 0 0 0-.47.3.3 0 0 0-.24-.1m-.83 9.33q-.28-.45-.65-.82a.45.45 0 0 0-.52-.12A21 21 0 0 0 10.32 17a20 20 0 0 0-2.95 2.57.44.44 0 0 0-.1.52 5 5 0 0 0 1.13 1.74.45.45 0 0 0 .52.13q.69-.23 1.39-.52a22 22 0 0 0 7.4-5.07.44.44 0 0 0 .08-.52 5 5 0 0 0-.46-.93m-7.01.55.17.8a20 20 0 0 1 1.19-.76l-.26-2.05c-.06-.52-.25-.67-.66-.95l-.44-.28-2.7-1.78L8.89 6.8l1.43-.13 2.92-.27q.17 0 .17-.16V5.7a.2.2 0 0 0-.05-.13.2.2 0 0 0-.14-.05H8c-.66 0-1.16.26-1.43 1.11l-1 3.74c-.2.75 0 1.45.74 1.81l3.65 1.65zM8.17 4.98a1.6 1.6 0 0 0 1.6-.57 1.5 1.5 0 0 0-.57-2.26 1.6 1.6 0 0 0-1.69.24 1.5 1.5 0 0 0-.28 1.9q.32.53.94.69"
  })
}));
IconWaterski.displayName = 'IconWaterski';